import { AspectRatio, Center, Skeleton } from '@chakra-ui/react'
import React from 'react'

function MenuLoading() {
  return (
    <>
      <Center gap={{ base: 4, lg: 11 }}>
        <Center flexDir={'column'} gap={2}>
          <AspectRatio
            ratio={1 / 1}
            minW={{ base: '122px', lg: '288px' }}
            w='full'
            rounded='20px'
            overflow='hidden'
          >
            <Skeleton
              rounded={12}
              maxH={'288px'}
              maxW={'288px'}
              w={'full'}
              aspectRatio='1 / 1'
            />
          </AspectRatio>
          <Skeleton rounded={12} height={4} w={'90%'} />
        </Center>
        <Center flexDir={'column'} gap={2}>
          <AspectRatio
            ratio={1 / 1}
            minW={{ base: '122px', lg: '288px' }}
            w='full'
            rounded='20px'
            overflow='hidden'
          >
            <Skeleton
              rounded={12}
              maxH={'288px'}
              maxW={'288px'}
              w={'full'}
              aspectRatio='1 / 1'
            />
          </AspectRatio>
          <Skeleton rounded={12} height={4} w={'90%'} />
        </Center>
        <Center flexDir={'column'} gap={2}>
          <AspectRatio
            ratio={1 / 1}
            minW={{ base: '122px', lg: '288px' }}
            w='full'
            rounded='20px'
            overflow='hidden'
          >
            <Skeleton
              rounded={12}
              maxH={'288px'}
              maxW={'288px'}
              w={'full'}
              aspectRatio='1 / 1'
            />
          </AspectRatio>
          <Skeleton rounded={12} height={4} w={'90%'} />
        </Center>
        <Center flexDir={'column'} gap={2}>
          <AspectRatio
            ratio={1 / 1}
            minW={{ base: '122px', lg: '288px' }}
            w='full'
            rounded='20px'
            overflow='hidden'
            display={{ base: 'none', lg: 'block' }}
          >
            <Skeleton
              rounded={12}
              maxH={'288px'}
              maxW={'288px'}
              w={'full'}
              aspectRatio='1 / 1'
            />
          </AspectRatio>
          <Skeleton rounded={12} height={4} w={'90%'} />
        </Center>
      </Center>
    </>
  )
}

export default MenuLoading
